import { render, staticRenderFns } from "./PrmClient.vue?vue&type=template&id=703c7fe4&scoped=true&"
import script from "./PrmClient.vue?vue&type=script&lang=js&"
export * from "./PrmClient.vue?vue&type=script&lang=js&"
import style0 from "./PrmClient.vue?vue&type=style&index=0&id=703c7fe4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c7fe4",
  null
  
)

component.options.__file = "PrmClient.vue"
export default component.exports